import React, { useState } from 'react';
import RolesPage from './components/pages/RolesPage';
import DetailedOnboardingChecklist from './components/onboarding/DetailedOnboardingChecklist';
import './App.css';

function App() {
  const [selectedProfile, setSelectedProfile] = useState(null);

  const handleRoleSelect = (profile) => {
    setSelectedProfile(profile);
  };

  const handleBackToRoles = () => {
    setSelectedProfile(null);
  };

  return (
    <div className="App">
      {selectedProfile ? (
        <DetailedOnboardingChecklist 
          initialProfile={selectedProfile}
          onBackToRoles={handleBackToRoles}
        />
      ) : (
        <RolesPage onRoleSelect={handleRoleSelect} />
      )}
    </div>
  );
}

export default App;